module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAA/CAYAAAC2NAWOAAAAAXNSR0IArs4c6QAAARFJREFUeAHt0r0NwjAYBmEnRPwUVLRswAQsQsUKgGAOpIhMAg1MBRJtRGLofWlofS7P1ffoDcGXCtyaw/ne7CbpT76ljDGuZvNFkS9BenmZJososAFRRAEBSC5FFBCA5FJEAQFILkUUEIDkUkQBAUguRRQQgORSRAEBSC5FFBCA5FJEAQFILkUUEIDkUkQBAUguRRQQgORSRAEBSC5FFBCA5FJEAQFILkUUEIDkUkQBAUguRRQQgORSRAEBSC5FFBCA5FJEAQFILkUUEIDkUkQBAUguRRQQgORSRAEBSC5FFBCAVFwv+8evP0OMHfxnldq+Om5O9avqR932046nWV0/dOxy/Q6hHvq1K6CAAn8JfAHqnRjz9iyoRgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/jpg/GMV同比.png
// module id = x64p
// module chunks = 1